import cloneDeep from 'lodash/cloneDeep'

class MealOptionFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        if (entity['discountPrice'] == '') {
            entity['discountPrice'] = null
        }

        if (entity?.supplierPrice == '') {
            entity.supplierPrice = null
        }

        entity.kcal = entity.kcal ? parseInt(entity.kcal) : null
        entity.portionSize = entity.portionSize
            ? parseInt(entity.portionSize)
            : 1
        if (!entity.servingStyle) {
            entity.servingStyle = 'individual'
        }
        entity.ecoFriendlyPackaging = !!entity.ecoFriendlyPackaging

        return entity
    }

    fromEntity(entity) {
        const formData = cloneDeep(entity)

        return formData
    }
}

export default new MealOptionFormMapper()
